import { httpClient } from "../../../shared/api/httpClient";

const extractUsers = (value: unknown): unknown[] => {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== "object") return [];

  const response = value as Record<string, unknown>;
  for (const key of ["items", "users", "data"]) {
    if (Array.isArray(response[key])) return response[key] as unknown[];
  }
  return [];
};

export const listProposalCoordinatorEmails = async (): Promise<string[]> => {
  const response = await httpClient.get<unknown>("/users/proposal-coordinators");
  const emails = extractUsers(response.data)
    .map((item) => {
      if (typeof item === "string") return item;
      if (!item || typeof item !== "object") return "";
      const email = (item as Record<string, unknown>).email;
      return typeof email === "string" ? email.trim() : "";
    })
    .filter(Boolean);
  return [...new Set(emails)];
};
